import React from 'react';

// Components
import { SortableHandle } from 'react-sortable-hoc';
import ReorderIcon from '@material-ui/icons/Reorder';

interface SortableHandleElemProps {
  className: string;
}

export default SortableHandle(({ className }: SortableHandleElemProps) => (
  <ReorderIcon className={className} />
));
